export const navItems = [
  { label: "最新收录", href: "#latest" },
  { label: "热度榜", href: "#ranking" },
  { label: "打包合集", href: "#packages" },
  { label: "人物索引", href: "#persons" },
  { label: "事件追踪", href: "#events" },
  { label: "收录守则", href: "#guide" },
];

export const tickerItems = [
  "今日新增收录 42 组图集",
  "「深夜直播」事件合集已补档至 186 张",
  "热度榜 · 早期旧照系列连续 3 日登顶",
  "打包专区新增 9 个高清整包",
  "人物索引新增 27 位条目",
  "原图模式已全量开启，可逐张浏览",
];

export const heroStats = [
  { label: "累计收录图集", value: "12,480", unit: "组" },
  { label: "人物条目", value: "3,962", unit: "位" },
  { label: "事件归档", value: "1,207", unit: "起" },
  { label: "今日更新", value: "42", unit: "组" },
];

export const quickFilters = [
  { key: "all", label: "全部收录" },
  { key: "person", label: "人物合集" },
  { key: "event", label: "事件归档" },
  { key: "pack", label: "打包专区" },
];

export const hotRanking = [
  { rank: 1, title: "深夜直播切片截图全档", person: "深夜的橘子", heat: "986.2万", trend: "up", tag: "持续升温" },
  { rank: 2, title: "机场路透长焦原图整组", person: "南栀不眠", heat: "742.8万", trend: "up", tag: "原图首发" },
  { rank: 3, title: "品牌活动同框机位合集", person: "巷口老陈", heat: "621.4万", trend: "flat", tag: "稳定高热" },
  { rank: 4, title: "早期旧照回档整理版", person: "糖不甜了", heat: "538.6万", trend: "up", tag: "补档完成" },
  { rank: 5, title: "综艺片段逐帧截图", person: "阿泽同学", heat: "472.1万", trend: "down", tag: "热度回落" },
  { rank: 6, title: "街头偶遇随拍合集", person: "一只鹿呀", heat: "410.9万", trend: "up", tag: "新增 36 张" },
  { rank: 7, title: "旧杂志扫描件修复版", person: "夜航船", heat: "356.3万", trend: "flat", tag: "高清修复" },
  { rank: 8, title: "历年活动出场整理", person: "半糖去冰", heat: "302.7万", trend: "down", tag: "归档完成" },
];

export const galleryItems = [
  {
    id: "g1",
    title: "深夜直播事件 · 全程截图归档",
    person: "深夜的橘子",
    event: "深夜直播事件",
    count: 186,
    updated: "2 小时前",
    views: "48.2 万",
    type: "event",
    badge: "今日新增",
    image:
      "https://readdy.ai/api/search-image?query=blurred%20dark%20crimson%20and%20charcoal%20bokeh%20city%20night%20lights%2C%20heavy%20film%20grain%2C%20moody%20cinematic%20editorial%20photography%2C%20soft%20out%20of%20focus%20highlights%2C%20deep%20shadow%20tones%2C%20abstract%20atmosphere%2C%20no%20text&width=800&height=600&seq=hlz-g-01&orientation=landscape",
  },
  {
    id: "g2",
    title: "机场路透 · 长焦机位原图整组",
    person: "南栀不眠",
    event: "机场路透合集",
    count: 132,
    updated: "5 小时前",
    views: "36.9 万",
    type: "person",
    badge: "原图模式",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20crinkled%20matte%20paper%20texture%20with%20warm%20amber%20side%20light%2C%20subtle%20dust%20particles%2C%20minimal%20editorial%20still%20life%2C%20soft%20directional%20shadow%2C%20muted%20neutral%20tones%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=hlz-g-02&orientation=landscape",
  },
  {
    id: "g3",
    title: "品牌活动同框 · 多机位整理",
    person: "巷口老陈",
    event: "品牌活动同框",
    count: 98,
    updated: "昨天",
    views: "29.4 万",
    type: "event",
    badge: "多机位",
    image:
      "https://readdy.ai/api/search-image?query=deep%20crimson%20ink%20slowly%20diffusing%20through%20clear%20water%2C%20macro%20abstract%20texture%2C%20dramatic%20studio%20lighting%2C%20rich%20saturated%20red%20pigment%2C%20smooth%20flowing%20forms%2C%20dark%20background%2C%20no%20text&width=800&height=600&seq=hlz-g-03&orientation=landscape",
  },
  {
    id: "g4",
    title: "早期旧照 · 回档整理全收录",
    person: "糖不甜了",
    event: "早期旧照回档",
    count: 214,
    updated: "昨天",
    views: "53.1 万",
    type: "person",
    badge: "补档完成",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20sepia%20photo%20album%20pages%20stacked%20at%20an%20angle%20with%20warm%20window%20light%2C%20aged%20paper%20edges%2C%20soft%20shallow%20depth%20of%20field%2C%20nostalgic%20editorial%20still%20life%2C%20muted%20brown%20tones%2C%20no%20text&width=800&height=600&seq=hlz-g-04&orientation=landscape",
  },
  {
    id: "g5",
    title: "综艺片段 · 逐帧截图合集",
    person: "阿泽同学",
    event: "综艺片段截图",
    count: 76,
    updated: "2 天前",
    views: "21.8 万",
    type: "event",
    badge: "逐帧版",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20teal%20and%20charcoal%20smoke%20wisps%20against%20dark%20gradient%20backdrop%2C%20cinematic%20studio%20lighting%2C%20smooth%20elegant%20texture%2C%20soft%20grain%2C%20moody%20editorial%20atmosphere%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=hlz-g-05&orientation=landscape",
  },
  {
    id: "g6",
    title: "街头偶遇 · 随拍原图打包",
    person: "一只鹿呀",
    event: "街头偶遇随拍",
    count: 64,
    updated: "3 天前",
    views: "18.3 万",
    type: "pack",
    badge: "整包可下",
    image:
      "https://readdy.ai/api/search-image?query=rainy%20night%20pavement%20reflecting%20warm%20amber%20and%20crimson%20lights%2C%20blurred%20long%20exposure%20bokeh%2C%20moody%20cinematic%20editorial%20photography%2C%20wet%20texture%20highlights%2C%20deep%20shadow%20tones%2C%20no%20text&width=800&height=600&seq=hlz-g-06&orientation=landscape",
  },
];

export const packages = [
  {
    title: "热度 TOP30 事件整包",
    desc: "近 30 日热度最高的 30 起事件原图合集，按事件分文件夹归档，一次取齐。",
    count: 2840,
    size: "6.4 GB",
    format: "JPG / ZIP",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20matte%20black%20archive%20folders%20with%20warm%20amber%20edge%20light%2C%20minimal%20editorial%20still%20life%2C%20soft%20shadow%2C%20dark%20studio%20background%2C%20clean%20composition%2C%20no%20text&width=640&height=420&seq=hlz-pack-01&orientation=landscape",
  },
  {
    title: "人物合集 · 全收录精简包",
    desc: "按人物抽取精简后的高清图集，已去重去水印，适合快速翻看完整记录。",
    count: 1960,
    size: "4.1 GB",
    format: "JPG / ZIP",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20muted%20teal%20document%20boxes%20arranged%20neatly%20with%20soft%20overhead%20light%2C%20minimal%20editorial%20still%20life%2C%20clean%20negative%20space%2C%20dark%20neutral%20background%2C%20no%20text&width=640&height=420&seq=hlz-pack-02&orientation=landscape",
  },
  {
    title: "高清原图 · 无损整档包",
    desc: "保留原始分辨率与拍摄参数的整档包，逐张可放大查看细节，收录最全版本。",
    count: 4210,
    size: "11.8 GB",
    format: "PNG / ZIP",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20crimson%20velvet%20texture%20folded%20with%20soft%20directional%20light%2C%20luxurious%20moody%20editorial%20still%20life%2C%20rich%20shadow%20depth%2C%20minimal%20composition%2C%20no%20text&width=640&height=420&seq=hlz-pack-03&orientation=landscape",
  },
];

export const persons = [
  {
    name: "深夜的橘子",
    handle: "@midnight_orange",
    count: 12,
    heat: "986 万",
    tag: "热度登顶",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20crimson%20gradient%20portrait%20placeholder%20with%20soft%20grain%2C%20minimal%20editorial%20texture%2C%20rounded%20soft%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-01&orientation=squarish",
  },
  {
    name: "南栀不眠",
    handle: "@nanzhi_sleep",
    count: 9,
    heat: "742 万",
    tag: "原图首发",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20amber%20gold%20gradient%20portrait%20placeholder%20with%20fine%20grain%2C%20minimal%20editorial%20texture%2C%20soft%20radial%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-02&orientation=squarish",
  },
  {
    name: "巷口老陈",
    handle: "@alley_chen",
    count: 15,
    heat: "621 万",
    tag: "多机位",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20deep%20teal%20gradient%20portrait%20placeholder%20with%20soft%20grain%2C%20minimal%20editorial%20texture%2C%20gentle%20side%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-03&orientation=squarish",
  },
  {
    name: "糖不甜了",
    handle: "@sugar_less",
    count: 11,
    heat: "538 万",
    tag: "补档完成",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20muted%20rose%20gradient%20portrait%20placeholder%20with%20soft%20grain%2C%20minimal%20editorial%20texture%2C%20even%20soft%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-04&orientation=squarish",
  },
  {
    name: "阿泽同学",
    handle: "@aze_classmate",
    count: 7,
    heat: "472 万",
    tag: "逐帧版",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20slate%20grey%20gradient%20portrait%20placeholder%20with%20soft%20grain%2C%20minimal%20editorial%20texture%2C%20cool%20soft%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-05&orientation=squarish",
  },
  {
    name: "一只鹿呀",
    handle: "@deer_here",
    count: 6,
    heat: "410 万",
    tag: "新增 36 张",
    avatar:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20brown%20gradient%20portrait%20placeholder%20with%20soft%20grain%2C%20minimal%20editorial%20texture%2C%20warm%20soft%20lighting%2C%20dark%20neutral%20background%2C%20no%20text%20no%20face&width=240&height=240&seq=hlz-p-06&orientation=squarish",
  },
];

export const events = [
  {
    date: "2026.09.11",
    title: "深夜直播事件",
    summary: "全程切片与截图归档完成，共补入 186 张原图，按时间线排序。",
    count: 186,
    status: "已补档",
  },
  {
    date: "2026.09.08",
    title: "机场路透合集",
    summary: "长焦机位原图整组上线，附带拍摄参数信息，支持逐张放大查看。",
    count: 132,
    status: "进行中",
  },
  {
    date: "2026.09.05",
    title: "品牌活动同框",
    summary: "多机位素材汇总去重，整理为一份完整图集，标注出现顺序。",
    count: 98,
    status: "已归档",
  },
  {
    date: "2026.09.01",
    title: "早期旧照回档",
    summary: "历年零散旧照集中回档整理，修复清晰度后统一编号收录。",
    count: 214,
    status: "已归档",
  },
  {
    date: "2026.08.28",
    title: "综艺片段截图",
    summary: "节目片段逐帧截图整理，按出现时间切分为若干小节便于浏览。",
    count: 76,
    status: "已归档",
  },
];

export const guides = [
  {
    step: "01",
    title: "按人物检索",
    desc: "进入人物索引，选择对应条目即可看到该人物的全部收录图集，按时间从新到旧排列。",
    icon: "ri-user-search-line",
  },
  {
    step: "02",
    title: "按事件追踪",
    desc: "事件归档以时间线呈现，每起事件都标注收录进度与补档状态，方便判断是否完整。",
    icon: "ri-timeline-view",
  },
  {
    step: "03",
    title: "原图与高清模式",
    desc: "合集内默认提供缩略预览，切换原图模式后可逐张查看高清版本，细节完整保留。",
    icon: "ri-image-2-line",
  },
  {
    step: "04",
    title: "打包整取",
    desc: "打包专区把同一事件或人物的图集压缩为整包，一次性取齐，省去逐页翻找的时间。",
    icon: "ri-folder-zip-line",
  },
];

export const guideNotes = [
  "所有内容均按人物与事件分类整理，站内只做信息归档与索引展示。",
  "收录进度会持续更新，图集数量与体积以合集页内实际显示为准。",
  "原图模式加载较慢，建议在网络稳定的环境下逐张浏览完整记录。",
];

export const footerGroups = [
  {
    title: "内容分区",
    links: [
      { label: "最新收录", href: "#latest" },
      { label: "热度榜", href: "#ranking" },
      { label: "打包合集", href: "#packages" },
      { label: "事件追踪", href: "#events" },
    ],
  },
  {
    title: "检索入口",
    links: [
      { label: "人物索引", href: "#persons" },
      { label: "事件归档", href: "#events" },
      { label: "原图模式", href: "#latest" },
      { label: "高清整包", href: "#packages" },
    ],
  },
  {
    title: "使用说明",
    links: [
      { label: "收录守则", href: "#guide" },
      { label: "更新订阅", href: "#subscribe" },
      { label: "常见问题", href: "#guide" },
      { label: "内容反馈", href: "#guide" },
    ],
  },
];